const types = {
  MELHOR_ENVIO: 1,
  MERCADO_LIVRE: 2,
  AMAZON: 3,
  MAGAZINE_LUIZA: 4,
  BLING: 5,
  CLEAR_SALE: 6,
  IUGU: 7,
  TOTVS_WINTHOR: 8
};

export default types;
